import {useCallback} from 'react';
import {downloadBlob, sanitizeFilename} from '../../../../../utils/download';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import {trackInstanceParametersExportedWord} from '../../../../../tracking/tracking';
import {useScenarioDetailLoaderWithParams} from '../../../../../store/scenario';
import {Document, Packer, Paragraph, Table, TableRow, TableCell, TextRun} from 'docx';

interface ScenarioParameter {
  key: string;
  value: any;
}

const useScenarioParametersExportToWord = ({model, subModel, scenario}: Partial<ScenarioActionProps>) => {
  const detailLoader = useScenarioDetailLoaderWithParams();

  const convertToWord = useCallback(
    (arrayObject: ScenarioParameter[]) => {
      const rows = [
        new TableRow({
          children: [
            new TableCell({children: [new Paragraph('key')]}),
            new TableCell({children: [new Paragraph('value')]}),
          ],
        }),
        ...arrayObject.map(
          (row) =>
            new TableRow({
              children: [
                new TableCell({children: [new Paragraph(String(row.key))]}),
                new TableCell({children: [new Paragraph(String(row.value))]}),
              ],
            }),
        ),
      ];

      return new Document({
        sections: [
          {
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: scenario ? scenario.name : 'JSON Data Export',
                    bold: true,
                    size: 32,
                  }),
                ],
                spacing: {after: 300},
              }),
              new Table({rows}),
            ],
          },
        ],
      });
    },
    [scenario],
  );

  return useCallback(() => {
    if (model && scenario && subModel) {
      detailLoader([scenario.id]).then((scenarioDetail: any) => {
        const parameters = scenarioDetail.input.value ? JSON.parse(scenarioDetail.input.value) : {};
        const arrayObject = Object.entries(parameters).map(([key, value]) => ({key, value}));
        const doc = convertToWord(arrayObject);
        Packer.toBlob(doc).then((blob) => {
          downloadBlob(blob, `${sanitizeFilename(scenario.name)}.docx`);
          trackInstanceParametersExportedWord(model, subModel, scenario);
        });
      });
    }
  }, [model, subModel, scenario, detailLoader, convertToWord]);
};

export default useScenarioParametersExportToWord;
